import { get, set } from 'lodash'
import { SUBCATEGORIES } from 'constants/layout/setup-activity'

export default (
  fields,
  id,
  activitySection,
  options = { isAdditional: false }
) => {
  const schema = {
    ...fields,
    isMajor: Boolean(get(fields, 'isMajor')),
    id,
    helpers: undefined,
    activityCategory: {}
  }

  if (get(fields, 'helpers.subcategory') === SUBCATEGORIES.others.value) {
    schema.activityCategory = {
      activitySection,
      parent: {
        id: get(fields, 'helpers.category')
      },
      userDefined: true,
      name: get(fields, 'helpers.others')
    }
  } else {
    schema.activityCategory.id = get(fields, 'helpers.subcategory')
  }

  if (options.isAdditional) {
    schema.activitySection = { value: activitySection }

    if (get(schema, 'activityCategory.activitySection')) {
      set(schema, 'activityCategory.activitySection', undefined)
    }
  }

  return schema
}
